import { Clock, Location } from '../../assets/icons';

export const WorkHoursCard = ({ workHours, address }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start gap-2">
        <div className="mt-1"><Clock className={'w-5 h-5 text-gray-400'}/></div>
        <div>
          {workHours.map(workHour => (
            <p key={workHour} className="text-base">
              {workHour}
            </p>
          ))}
        </div>
      </div>
      <div className="flex items-start gap-2 mt-1">
        <div><Location className="w-5 h-5 text-gray-400" /></div>
        <div className="flex flex-col">
          {address.map((item) => (
            <a
              key={item.mapId}
              href={item.point}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};